module.exports = __webpack_public_path__ + "static/media/twitter.c4f438fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/social/twitter.svg
// module id = 28
// module chunks = 0